import { useCallback, useState } from 'react';
import { useAttentiveSubscribe } from '../../hooks/useEmailSubscribe/useAttentiveSubscribe';

export const useSmsPumoModule = () => {
  const [phone, setPhone] = useState('');
  const {
    subscribe,
    isSubscribed,
    loading,
    error,
    isEmailValid,
    isPhoneNumberValid,
    mailValidationError,
    phoneNumberValidationError
  } = useAttentiveSubscribe();

  const [email, setEmail] = useState('');

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      if (!isEmailValid(email)) return;
      if (!isPhoneNumberValid) return;

      subscribe(email, 'smsPumoModule', phone);
    },
    [email, isEmailValid, isPhoneNumberValid, phone, subscribe]
  );

  return {
    phone,
    handleChangePhone: setPhone,
    handleSubmit,
    error,
    mailValidationError,
    phoneNumberValidationError,
    email,
    isSubscribed,
    serverError: error,
    handleChangeEmail: setEmail,
    loading
  };
};
